module.exports = __webpack_public_path__ + "static/media/sk.5889d58a.svg";